<template>
  <Slide right>
    <router-link class="header-nav-link" to="/">
      <span>Home</span>
    </router-link>
    <router-link class="header-nav-link" to="/about-us/">
      <span>About us</span>
    </router-link>
    <router-link class="header-nav-link" to="/services/">
      <span>Services</span>
    </router-link>
    <router-link class="header-nav-link" to="/past-projects/">
      <span>Past projects</span>
    </router-link>
    <router-link class="header-nav-link" to="/contact-us/">
      <span>Contact Us</span>
    </router-link>
    <router-link to="/terms-of-use/">
      <span>Terms of Use</span>
    </router-link>
    <router-link to="/privacy-and-cookie-policy/">
      <span>Privacy &amp; Cookie Policy</span>
    </router-link>
    <a href="tel:01502711750" class="header-nav-link">
      <span>
        <strong>01502 711750</strong>
      </span>
    </a>
  </Slide>
</template>

<script>
import { Slide } from "vue-burger-menu";

export default {
  name: "mobile-menu",
  components: {
    Slide
  }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/MobileMenu.vue